import { getPreviousChannelConfig } from '../utils/getPreviousChannelConfig'
import { logDevelopmentMessage } from '../utils/logDevelopmentMessage'
import { publishChatStartedEvent } from './publishChatStartedEvent'

export const subscribeToAgentForceStartEvent = () => {
  const handleChatStartEvent = async (event: any) => {
    if (getPreviousChannelConfig()) return
    logDevelopmentMessage(`[AF] Start event received for ${JSON.stringify(event.detail)}`)
    try {
      window.embeddedservice_bootstrap?.prechatAPI?.setHiddenPrechatFields({
        Breadcrumb: event.detail.channel,
        ChatStartPageURL: window.location.href.slice(0,255),
      })
      const utilAPI = window.embeddedservice_bootstrap?.utilAPI
      if (!utilAPI) {
        throw new Error('embeddedservice_bootstrap.utilAPI is not available')
      }
      await utilAPI.launchChat()
      publishChatStartedEvent()
    } catch (error) {
      console.error(`[AF] Failed launching chat`, error)
      window.dispatchEvent(new CustomEvent('jl-AF-conversations-chat-initialisation-failed'))
    }
  }

  window.addEventListener('jl-AF-conversations-start-chat', handleChatStartEvent)
}
